import findBlockSettingComments from '../utils/helpers/find-block-setting-comments';

const getNodesByPresenceSetting = (containerElement, presenceSettings) => {
  const availableElements = containerElement.querySelectorAll(presenceSettings.childrenSelector);

  if (availableElements.length) return [...availableElements];

  return findBlockSettingComments(containerElement, presenceSettings.childrenSelector);
};

export default getNodesByPresenceSetting;
